import FoodMenuIcon from '@material-ui/icons/ViewList';

import PurchaseCancelRequestList from './PurchaseCancelRequestList';
import PurchaseCancelRequestShow from "./PurchaseCancelRequestShow";
import PurchaseCancelRequestCreate from "./PurchaseCancelRequestCreate";
import PurchaseCancelRequestEdit from "./PurchaseCancelRequestEdit";

export default {
    list: PurchaseCancelRequestList,
    show: PurchaseCancelRequestShow,
    create: PurchaseCancelRequestCreate,
    edit: PurchaseCancelRequestEdit,
    icon: FoodMenuIcon,
};
